module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrMedium.dfb22ae.eot";